import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AppSettings, Storage } from '../../configs'

import { logoutAction } from '../../redux/actions/UserAction'
import { ClearMasterAction } from '../../redux/actions/MasterAction'
import { setNotActivePOAction } from '../../redux/actions/DocControlAction'
import Avatar from '@material-ui/core/Avatar';

const initial_hamberger_status = {
    aria_expanded: false,
    class: 'collapsed',
    collapsed: 'collapse',
};



class CollapseDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hamberger_status: initial_hamberger_status,
            isExpand : this.props.isExpand === undefined || this.props.isExpand=== 'Y',
        };
        this.handleCollapse = this.handleCollapse.bind(this)
    }

    handleCollapse() {
        
        window.$('#collapseItemOverview'+this.props.id).toggleClass('show');
        window.$('#collapseItemOverview'+this.props.id).focus();
        const {isExpand} = this.state
        this.setState({...this.state,isExpand:!isExpand})

    }

    render() {

        const {isExpand} = this.state
        return (
            <div  >
                <div className={this.props.isExpand === undefined || this.props.isExpand==='N' ? "collapse collapse-onlinereviewer2 show" : "collapse collapse-onlinereviewer2" } id={"collapseItemOverview"+this.props.id} >
                {/* <div className="sp-page-wrapper">
                        <div className="sp-table-container">
                            <div className="row no-gutters">  */}
                            {this.props.children}

                                    {/* </div>
                                </div>
                            </div>  */}
                                    
                </div> 
    </div>
        )
    }
}


export default connect(
)(CollapseDetail);
